import { useCallback } from 'react'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'

export const useOpenUnifiedMeetingBriefsFromHost = () => {
  const enforceMeetingPrep = useEnforceUpgrade('crm_meeting_prep', {
    skipPreface: true,
  })

  return useCallback(async (payload) => {
    let didOpen = false

    await enforceMeetingPrep(async () => {
      try {
        const module = await import(
          /* webpackChunkName: "oap_web_host_unified_meeting_briefs" */
          'oap_web/HostUnifiedMeetingBriefs'
        )

        if (!module.openUnifiedMeetingBriefsFromHost) return

        await module.openUnifiedMeetingBriefsFromHost(payload)
        didOpen = true
      } catch {
        // Remote missing/outdated — intentionally no-op.
      }
    })

    return didOpen
  }, [enforceMeetingPrep])
}
